export default "__VITE_ASSET__D22QLJ6M__"